import axios from 'axios';
import qs from 'qs';

// const dataUrl = 'https://zhiye-test-api.ksbao.com/api'; //本地
const dataUrl = 'https://zhiye-api.ksbao.com/api'; //线上
export const purchasedUserList = params => {
    return axios.get(`${dataUrl}/purchasedUserList`, {
        params: params
    })
}
// export const getMindMapping = params => {
//     return axios.post(`${dataUrl}/testBank/getMindMapping`, qs.stringify(params))
// }
export const getMindMapping = params => {
    return axios.get(`${dataUrl}/testBank/getMindMapping`, {
        params: params
    })
}
//登录
export const login = params => {
    return axios.post(`${dataUrl}/user/login`, qs.stringify(params))
}
//获取科目列表
export const menuList = params => {
    return axios.get(`${dataUrl}/user/home/getAppList`, {
        params: params
    })
}
// 获取vip价格
export const getVipPrice = params => {
    return axios.get(`${dataUrl}/user/pay/getVipPrice`, {
        params: params
    })
}
//充值币购买
export const virtualCoinPay = params => {
    return axios.post(`${dataUrl}/user/pay/virtualCoinPay`, qs.stringify(params))
}
//helpCenter 帮助中心
export const paymentFAQs = params => {
    return axios.get(`${dataUrl}/user/pay/paymentFAQs`, {
        params: params
    })
}
//当前用户是否时会员
export const getVipInfo = params => {
    return axios.get(`${dataUrl}/user/pay/getVipInfo`, {
        params: params
    })
}
//获取vip特权列表
export const getVipMenus = params => {
    return axios.get(`${dataUrl}/user/home/getVipMenus`, {
        params: params
    })
}
//充值接口
export const rechargeWxMiniProgram = params => {
    return axios.post(`${dataUrl}/user/pay/rechargeNew`, qs.stringify(params))
}